<template>
  <ValidationObserver v-slot="{ invalid }">
    <b-overlay :show="busy" rounded="sm">
      <form @submit="sendForm">
        <div v-if="isLoaded">
          <b-row>
            <b-col sm="12" md="6">
              <label>Data dostawy</label>
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-datepicker id="DeliveryDate" v-model="baseForm.deliveryDate" class="mb-2"></b-form-datepicker>
                <b-alert v-if="errors.length > 0" show variant="danger">{{ errors[0] }}</b-alert>
              </validation-provider>
            </b-col>
            <ProducerPicker ref="producerPicker"/>
            <b-col b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Numer rejestracyjny pojazdu</label>
                <v-select label="name" class="vehicle" :options="vehicles" v-model="baseForm.vehicle"/>
                <b-alert v-if="errors.length > 0" show variant="danger">{{ errors[0] }}</b-alert>
              </validation-provider>
            </b-col>
            <b-col b-col sm="12" md="6">
              <QuickAdd dispatchName="addVehicle" title="Dodaj samochód dostawcy"
                        description="Nie widzisz samochodu na liście? Dodaj go."/>
            </b-col>
          </b-row>
          <b-row>
            <b-col b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Rodzaj dokumentu</label>
                <v-select :options="invoiceTypeOptions" class="invoiceType" :reduce="(x) => x.value"
                          v-model="baseForm.invoiceType"></v-select>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
            <b-col b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Numer faktury lub WZ</label>
                <input type="text" class="form-control invoiceNumber" placeholder="Numer faktury lub WZ"
                       v-model="baseForm.invoiceNumber"/>
                <b-alert class="mt-2" v-show="errors[0] !== undefined" show variant="danger">{{ errors[0] }}</b-alert>
              </validation-provider>
            </b-col>
            <b-col b-col sm="12" md="6">
              <label>Data wystawienia faktury</label>
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-datepicker id="invoiceCreationDate" v-model="baseForm.invoiceCreationDate"
                                   class="mb-2"></b-form-datepicker>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-group label="Waluta">
                  <v-select :options="currencyList" :reduce="(x) => x.value"
                            v-model="baseForm.currency"></v-select>
                </b-form-group>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
          </b-row>

          <div class="accordion" role="tablist">
            <RawMaterialDelivery v-for="item in baseForm.RawMaterials" :rawMaterial="item" :key="item.id"
                                 :producer="producer" :countries="countries" :products="products"
                                 @removeItem="RemoveRawMaterialDeliveryFromList"/>
          </div>

          <button type="button" class="btn btn-info btn-block not-collapsed addRawMaterial" style="overflow-anchor: none"
                  @click="addRawMaterial()">
            Dodaj produkt
          </button>

          <b-row>
            <div class="col align-self-end div-form-buttons-area">
              <button type="submit" class="btn-primary btn" :disabled="invalid">
                Zapisz
              </button>
              <button type="button" class="btn-warning btn">
                Wyczyść formularz
              </button>
            </div>
          </b-row>
        </div>
        <div v-show="!isLoaded">
          <Loading ref="loadingSpinner"/>
        </div>
      </form>
    </b-overlay>
  </ValidationObserver>
</template>

<script>
import RawMaterialDelivery from './RawMaterialDelivery';
import {ValidationObserver} from 'vee-validate';
import deliveryMixin from '../../../mixins/delivery';
import currencyMixin from '../../../mixins/currencyMixin';
import ddOptions from '../../../mixins/dropDownOptions';
import QuickAdd from '../../Common/QuickAdd';
import Loading from '../../Common/Loading';
import ProducerPicker from '../Shared/ProducerPicker.vue';
import moment from 'moment'

const deliveryQuestionsPreAnswers = [true, true, true, true, true, false];

export default {
  name: 'AddDelivery',
  components: {RawMaterialDelivery, ValidationObserver, QuickAdd, Loading, ProducerPicker},
  mixins: [ddOptions, deliveryMixin,currencyMixin],
  computed: {
    vehicles() {
      return this.$store.state.deliveryFormData.vehicles;
    },
    countries() {
      return this.$store.state.deliveryFormData.countries;
    },
    producer() {
      return this.$store.state.deliveryFormData.producers;
    },
    products() {
      return this.$store.state.deliveryFormData.rawMaterialTypes;
    },
    deliveryQuestions() {
      return this.$store.state.deliveryFormData.deliveryQuestions;
    },
  },
  methods: {
    RemoveRawMaterialDeliveryFromList: function (itemId) {
      var indexes = this.baseForm.RawMaterials.reduce(function (a, e, i) {
        if (e.id === itemId[0]) a.push(i);
        return a;
      }, []);

      indexes.forEach((element) => {
        this.baseForm.RawMaterials.splice(element, 1);
      });
    },
    addRawMaterial: function () {
      //Ustawianie predefiniowanych odpowiedzi
      let questions = JSON.parse(JSON.stringify(this.deliveryQuestions));
      for (var i = 0; i < questions.length; i++) {
        questions[i].isPassed = deliveryQuestionsPreAnswers[i];
      }

      this.baseForm.RawMaterials.push({
        id: this.globalCounter++,
        deliveryQuestions: questions,
        IsDeliveryApproved: true
      });
    },

    sendForm: function (evt) {
      var that = this;
      evt.preventDefault();
      const producerPicker = this.$refs.producerPicker;
      if (producerPicker.isCertificateValid) {
        this.baseForm.RawMaterials.forEach(item => item.producer = producerPicker.selectedProducer)
        this.busy = true;
        this.newDelivery(this.baseForm)
            .then(function (res) {
              let routeData = that.$router.resolve({name: 'nalepkiDostawa', params: {id: res.data}});
              window.open(routeData.href, '_blank');
              window.location.href = '/#/PodsumowanieDostawy/' + res.data;
            })
            .catch(function (e) {
              console.log(e);
              that.busy = false;
            });
      } else {
        that.DisplayError(
            'Brak waznego certyfikatu!',
            producerPicker.selectedProducer.name + ' posiada nie wazny certyfikat!'
        );
      }
    },
  },
  mounted() {
    this.$store.dispatch('getDeliveryFromData').then(() => {
      this.addRawMaterial();
      this.isLoaded = true;
    });
  },
  data() {
    return {
      busy: false,
      globalCounter: 1,
      isLoaded: false,
      baseForm: {
        deliveryDate: moment().format("YYYY-MM-DD"),
        invoiceNumber: '',
        vehicle: '',
        RawMaterials: [],
        currency:0,
      },
    };
  },
};
</script>
